<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import { dkdj_fetchResultShow } from "../../../../../api/dkdj.js";
import config from "../../../../../../configHttp.js";
import {MainFunction} from "@/components/util/Function/MainFunction";
export default {
  data: function () {
    return {
      suosq:  MainFunction.$getdefultMonth(),
      searchdata: [],
      searchlist: [],
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [],
      shaidiag: false,
      searchdiag: false,
      // 日期控件初始化时间
      dateValue: "",
      // 导出传参类型
      outputData: getdata().outputData,
      // 全部导出
      exportType: "1",
      tablekey: 0,
    };
  },
  methods: {
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchResultShow();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchResultShow();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchResultShow();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchResultShow();
    },

    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    // 查询进行发票合计结果(分页)
    fetchResultShow() {
      let params = {
        suosq: this.suosq,
        current: this.pagination.pageNum,
        size: this.pagination.pageSize,
        sort: "",
        order: ""
      }
      dkdj_fetchResultShow(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    suosqchange() {
      this.fetchResultShow();
    },
    // 导出进项发票合计结果
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let data = {
        suosq: this.suosq
      };
      if (selectVal.length > 0) {
        data.companyCodes = selectVal.map((item) => item.companyCode);
      }
      let params = {
        downUrl: config.baseURL + "dkdj/list/export",
        typeObj: {
          toForm: false,
          fileName: "代扣代缴结果展示" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
  },
  components: {},
  created() {
    this.fetchResultShow();
  },
  mounted() {},
  computed: {},
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
